import React, {
  useState,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';

import PAGES_TYPE from 'shared-constants/src/pagesType';
import { isValidString } from 'shared-utils/src/checkVarType';

import MapImg from '@async-components/HubPageMap';

import { fetchHubPage } from '../../common/redux/hubPage/actions';

import UiHandlerHOC from '../app/UiHandler';
import App from '../app/App';
import MetaInfo from '../components/common/metainfo/MetaInfo';
import Breadcrumb from '../components/searchPage/Breadcrumb/index';
import Spinner from '../components/common/Spinner/index';

import {
  SEOPagesNumrooms,
  SEOPageLinkPType,
  SEOPageTabLink,
  SEOPageFormatSelects,
  chooseSeoFooterToUse,
  hasToShowNumRooms,
  noresultsPType,
  formatAllLocList,
  createMessageMainHrefHubpage,
} from '../helpers/SEOPagesHelpers';

import {
  isChildOf,
} from '../helpers/DOMHelpers';

import './HubPage-critical.scss';
import { calculateKeyAndContextBasedOnAnchor, extractSRPUrls } from './helpers/seoData';

const propTypes = {
  device: PropTypes.string,
  category: PropTypes.string,
  channel: PropTypes.string,
  list: PropTypes.instanceOf(Array),
  channelMenuValues: PropTypes.instanceOf(Array),
  numRoomMenuValues: PropTypes.instanceOf(Array),
  licenseTypeGroupMenuValues: PropTypes.instanceOf(Array),
  pTypesMenuValues: PropTypes.instanceOf(Array),
  resolvedLocation: PropTypes.instanceOf(Object),
  total: PropTypes.string,
  uriToSearch: PropTypes.string,
  uriToSearchMap: PropTypes.string,
  seoData: PropTypes.instanceOf(Object),
  hubPage: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
  hash: PropTypes.string,
  config: PropTypes.instanceOf(Object),
};

const defaultProps = {
  device: '',
  category: '',
  channel: '',
  list: [],
  channelMenuValues: [],
  numRoomMenuValues: [],
  licenseTypeGroupMenuValues: [],
  pTypesMenuValues: [],
  resolvedLocation: {},
  total: '',
  uriToSearch: '',
  uriToSearchMap: '',
  seoData: {},
  hubPage: {},
  location: {},
  hash: '',
  config: {},
};

const HubPageComponent = (props) => {
  const {
    device,
    hubPage: {
      domain,
      channel,
      category,
      channelMenuValues,
      list: hubPageFromProps,
      resolvedLocation,
      buildingCondition,
      uriToSearch,
      pTypesMenuValues,
      numRoomMenuValues,
      licenseTypeGroupMenuValues,
      total,
      totalNumber,
      resolvedLocation: {
        centerPoint,
      },
      isAgencyHub,
      onlyAuction,
      shortRent,
      breadcrumb = {},
      filtersTabs = [],
    },
    config,
    seoData,
    location: {
      hash = '',
    },
  } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [loadMap, setLoadMap] = useState(false);
  const [numRooms, setNumRooms] = useState('');
  const [licenseTypeGroup, setLicenseTypeGroup] = useState('');
  const [ptype, setPtype] = useState('');
  const [contextTab, setContextTab] = useState('default');
  const [keyTab, setKeyTab] = useState('all');
  const [hubPageToUse, setHubPageToUse] = useState(chooseSeoFooterToUse({ context: contextTab, key: keyTab, seoFooterData: hubPageFromProps }));
  const [totalGroup, setTotalGroup] = useState(total);
  const [uriGroup, setUriGroup] = useState(uriToSearch);
  const [shouldShowNumRoomsMenu, setShouldShowNumRoomsMenu] = useState(hasToShowNumRooms({ category, ptype }));
  const [shouldShowLicenseTypeGroupsMenu, setShouldShowLicenseTypeGroupsMenu] = useState(false);
  const [withTowns, setWithTowns] = useState(hubPageToUse && hubPageToUse.length ? <p className="withTowns">Comuni in evidenza</p> : null);
  const hasPtype = isValidString(ptype);
  const allSRPUrlsToShowInHTMLSource = extractSRPUrls({ hubPage: hubPageFromProps });
  let ptypeForText;
  if (hasPtype) {
    ptypeForText = ptype;
  } else {
    ptypeForText = isValidString(buildingCondition) ? 'nuove-costruzioni' : category;
  }

  const locationName = resolvedLocation.name.replace(/-/g, ' ');
  const [buttonMessage, setButtonMessage] = useState(createMessageMainHrefHubpage({ 
    isAgencyHub, 
    numRooms, 
    ptypeForText, 
    locationName, 
    onlyAuction, 
    shortRent,
  }));


  useEffect(() => {
    if (hash) {      
      const {
        context: contextClc,
        key: keyClc,
        ptype: ptypeClc,
        nRooms: nRoomsClc,
        licenseTypeGroup: ltgClc,
      } = calculateKeyAndContextBasedOnAnchor({
        hash,
        filters: {
          channel,
          category,
        },
      });
      setPtype(ptypeClc);
      setContextTab(contextClc);
      setKeyTab(keyClc);
      setNumRooms(nRoomsClc);
      if (ltgClc) {
        setLicenseTypeGroup(ltgClc);
        const ltgSet = licenseTypeGroupMenuValues.filter(x => Object.keys(x)[0] === ptypeClc);
        setShouldShowLicenseTypeGroupsMenu(ltgSet.length > 0 ? ltgSet[0][ptypeClc] : false);
      }

      setShouldShowNumRoomsMenu(hasToShowNumRooms({ category, ptype: ptypeClc }));
      
      const hubPageToUseTemp = chooseSeoFooterToUse({ context: contextClc, key: keyClc, seoFooterData: hubPageFromProps });
      const generalInfo = chooseSeoFooterToUse({ context: contextClc, key: keyClc, seoFooterData: hubPageFromProps.generalInfo });
      setTotalGroup(generalInfo.totalCount);
      setUriGroup(generalInfo.searchLink);
      setHubPageToUse(hubPageToUseTemp);
      setWithTowns(hubPageToUseTemp && hubPageToUseTemp.length ? <p className="withTowns">Comuni in evidenza</p> : null);

      const msgBtn = createMessageMainHrefHubpage({
        isAgencyHub,
        numRooms,
        ptypeForText: ptypeClc,
        ltGroup: ltgClc,
        locationName,
        totalGroup: generalInfo.totalCount,
        onlyAuction,
        shortRent,
      });
      setButtonMessage(msgBtn);
    }
    setIsLoading(false);

  }, []);

  const titleMessage = seoData.seo.h1;
  const appNRooms = numRooms !== 0 ? SEOPagesNumrooms[numRooms]?.singular?.toLowerCase() : '';
  const noListing = (<p className="noResults">Al momento non ci sono {isAgencyHub ? 'agenzie immobiliari' : `annunci ${noresultsPType(ptypeForText, numRooms, { ptype, ltg: licenseTypeGroup ? shouldShowLicenseTypeGroupsMenu.filter(ltg => ltg.value === licenseTypeGroup)[0].name : null })}`} in provincia di {resolvedLocation.name}</p>);
  const tot = (totalGroup || '').replace('.', '');
  const noResultsMessage = !tot || parseInt(tot, 10) < 3 ? noListing : null;

  const allListDataHubPage = formatAllLocList({
    category: isValidString(buildingCondition) ? 'nuove-costruzioni' : category,
    hubPage: hubPageFromProps,
    isAgencyHub,
    onlyAuction,
    shortRent,
  });

  if (!loadMap) {
    setTimeout(() => setLoadMap(true), 2000);
  }

  const switchTab = ({ value = 'all', context = 'default' }) => {
    const val = value === 'all' ? '' : value;
    const hubPageToUseTemp = chooseSeoFooterToUse({ context, key: value, seoFooterData: hubPageFromProps });
    const generalInfo = chooseSeoFooterToUse({ context, key: value, seoFooterData: hubPageFromProps.generalInfo });
    setTotalGroup(generalInfo.totalCount);
    setUriGroup(generalInfo.searchLink);
    setContextTab(context);
    let ptypesForLinks = [];
    setKeyTab(value);
    setHubPageToUse(hubPageToUseTemp);

    switch (context) {
      case 'ptypes':
        if (category === 'commerciale') {
          const ltgSet = licenseTypeGroupMenuValues.filter(x => Object.keys(x)[0] === val);
          console.log(ltgSet);
          setShouldShowLicenseTypeGroupsMenu(ltgSet.length > 0 ? ltgSet[0][val] : false);
        } else {
          setShouldShowNumRoomsMenu(hasToShowNumRooms({ category, ptype: val }));
        }
        ptypesForLinks = SEOPageLinkPType({
          ptype: val,
          numRooms: '', 
          shortRent,
        });
        setPtype(val);
        setLicenseTypeGroup('');
        break;

      case 'nRooms':
        setNumRooms(val);
        ptypesForLinks = SEOPageLinkPType({
          ptype: true,
          numRooms: val,
          shortRent,
        });
        break;

      case 'licenseTypeGroups':
        setLicenseTypeGroup(val);
        if (!val) {
          setShouldShowLicenseTypeGroupsMenu(false);
          ptypesForLinks = SEOPageLinkPType({
            ptype,
            numRooms: '',
            shortRent,
          });
        } else {
          ptypesForLinks = SEOPageLinkPType({
            ptype: '',
            ltGroup: shouldShowLicenseTypeGroupsMenu.filter(ltg => ltg.value === val)[0].name,
            numRooms: '',
            shortRent,
          });
        }
        break;

      default:
        if (category === 'commerciale') {
          setLicenseTypeGroup('');
          setShouldShowLicenseTypeGroupsMenu(false);
        } else {
          setShouldShowNumRoomsMenu(hasToShowNumRooms({ category, ptype: '' }));
        }
        ptypesForLinks = SEOPageLinkPType({
          ptype: category,
          numRooms: '',
          shortRent,
        });
        setPtype(val);
        setNumRooms('');
        break;
    }
    setButtonMessage(`Vedi ${isAgencyHub ? 'Agenzie immobiliari' : ptypesForLinks} in provincia di ${locationName}`);
    setWithTowns(hubPageToUseTemp && hubPageToUseTemp.length ? <p className="withTowns">Comuni in evidenza</p> : null);
  };

  const onSelectChange = ({ e, data, values }) => {
    e.preventDefault();
    const select = e.target.parentNode.parentNode.parentNode;
    select.classList.remove('selectOpen');
    const newButtonValue = e.target.innerHTML === 'Tutti' ? `Scegli: ${values.map(innerType => innerType.name).join(', ')}` : e.target.innerHTML;
    select.firstChild.innerHTML = newButtonValue;
    if (
      e.target.innerHTML === 'Tutti'
      && !select.classList.contains('noselection')
    ) {
      select.classList.add('noselection');
    } else if (
      e.target.innerHTML !== 'Tutti'
      && select.classList.contains('noselection')
    ) {
      select.classList.remove('noselection');
    }
    const { value, group } = data;
    switch (group) {
      case 'nRooms':
      case 'ptypes':
        switchTab({ value, context: group });
        break;        
      case 'licenseTypeGroups':
        if (value) {
          switchTab({ value, context: group });
        } else {
          switchTab({ value: ptype, context: 'ptypes' });
        }
        break;
      case 'default':
        switchTab({ value: 'all', context: group });
        break;
      default:
        document.location = e.target.href;
        break;
    }
  };

  const outerClick = (e) => {
    const selectOpen = e.target.parentElement;
    if (!isChildOf(e.target, selectOpen)) {
      selectOpen.classList.remove('selectOpen');
      window.removeEventListener('click', outerClick);
    }
  };

  const onButtonClick = (e) => {
    if (e.target.parentNode.classList.contains('selectOpen')) {
      e.target.parentNode.classList.remove('selectOpen');
      window.removeEventListener('click', outerClick);
    } else {
      e.target.parentNode.classList.add('selectOpen');
      window.addEventListener('click', outerClick);
    }
  };

  const trackEvents = (
    track_category,
    action,
    label = undefined,
    value = undefined,
    nonInteraction = false,
  ) => {
    window.dataLayer.push({
      event: 'GAEvent',
      eventInfo: {
        category: track_category,
        action,
        label,
        value,
        nonInteraction,
      },
    });
  };

  const createHubPageChannelsTab = () => {
    if (isAgencyHub) {
      return null;
    }
    const catToUse = category === 'vacanze' ? 'residenziale' : category;
    const tabLink = SEOPageTabLink(catToUse, '', 0, null, false);
    const buyLinkAvailable = channelMenuValues.indexOf('vendita') > -1;
    const rentLinkAvailable = channelMenuValues.indexOf('affitto') > -1;
    const onlyAuctionLinkAvailable = filtersTabs.indexOf('only-auction') > -1;
    const shortRentLinkAvailable = filtersTabs.indexOf('case-vacanza') > -1;
    const locationUrl = `${resolvedLocation.slug}-provincia`;

    if (onlyAuction) {
      return (
        <ul className="tabs">
          {
            buyLinkAvailable
            && category !== 'stanze'
            && (
              <li>
                <a href={`/liste/vendita${tabLink}${locationUrl}/comuni/`} title="In affitto">In vendita</a>
              </li>
            )
          }
          {
            rentLinkAvailable
            && (
              <li>
                <a href={`/liste/affitto${tabLink}${locationUrl}/comuni/`} title="In affitto">In affitto</a>
              </li>
            )
          }
          <li>
            <strong>Aste</strong>
          </li>
          {
            shortRentLinkAvailable
            && (
              <li>
                <a href={`/liste/affitto/vacanza/${locationUrl}/comuni/`} title="Aste">Affitti Brevi</a>
              </li>
            )
          }
        </ul>
      );
    }

    if (shortRent) {
      return (
        <ul className="tabs">
          {
            buyLinkAvailable
            && category !== 'stanze'
            && (
              <li>
                <a href={`/liste/vendita${tabLink}${locationUrl}/comuni/`} title="In affitto">In vendita</a>
              </li>
            )
          }
          {
            rentLinkAvailable
            && (
              <li>
                <a href={`/liste/affitto${tabLink}${locationUrl}/comuni/`} title="In affitto">In affitto</a>
              </li>
            )
          }
          {
            onlyAuctionLinkAvailable
            && (
              <li>
                <a href={`/liste/vendita/residenziale/${locationUrl}/da-asta-immobiliare/comuni/`} title="Aste">Aste</a>
              </li>
            )
          }
          <li>
            <strong>Affitto Breve</strong>
          </li>
        </ul>
      );
    }

    if (channel === 'vendita') {
      return (
        <ul className="tabs">
          <li>
            <strong>In vendita</strong>
          </li>
          {
            rentLinkAvailable
            && (
              <li>
                <a href={`/liste/affitto${tabLink}${locationUrl}/comuni/`} title="In affitto">In affitto</a>
              </li>
            )
          }
          {
            onlyAuctionLinkAvailable
            && (
              <li>
                <a href={`/liste/vendita/residenziale/${locationUrl}/da-asta-immobiliare/comuni/`} title="Aste">Aste</a>
              </li>
            )
          }
          {
            shortRentLinkAvailable
            && (
              <li>
                <a href={`/liste/affitto/vacanza/${locationUrl}/comuni/`} title="Aste">Affitti Brevi</a>
              </li>
            )
          }
        </ul>
      );
    }
    return (
      <ul className="tabs">
        {
          buyLinkAvailable
          && category !== 'stanze'
          && (
            <li>
              <a href={`/liste/vendita${tabLink}${locationUrl}/comuni/`} title="In affitto">In vendita</a>
            </li>
          )
        }
        <li>
          <strong>In affitto</strong>
        </li>
        {
          onlyAuctionLinkAvailable
          && (
            <li>
              <a href={`/liste/vendita/residenziale/${locationUrl}/da-asta-immobiliare/comuni/`} title="Aste">Aste</a>
            </li>
          )
        }
        {
          shortRentLinkAvailable
          && (
            <li>
              <a href={`/liste/affitto/vacanza/${locationUrl}/comuni/`} title="Aste">Affitti Brevi</a>
            </li>
          )
        }


      </ul>
    );
  };

  /** contents */
  const goToSRP = !!totalGroup && parseInt((totalGroup || '').replace('.', ''), 10) > 2 ? (
    <a
      href={uriGroup}
      title={buttonMessage}
      className="goToSRP"
    >
      {buttonMessage} ({totalGroup})
    </a>
  ) : noResultsMessage;

  /**
   * To accomplish SEO rules, it has to be inject into html all the srp link 
   * values that in first instance are not shown.
   */
  const calculateHideGoToSrp = () => allSRPUrlsToShowInHTMLSource.map((curr) => {
    const titleButton = `Vedi ${isAgencyHub ? 'Agenzie immobiliari' : curr.typeForLink} in provincia di ${locationName} (${curr.totalCount})`
    return (
      <a
        href={curr.searchLink}
        title={titleButton}
        className="goToSRP"
      >
        {titleButton}
      </a>
    );
  });
  const appProps = {
    ...props,
    pageType: PAGES_TYPE.HUB_PAGE,
    trackEvents,
  };

  const createHubPageDataToRender = () => {
    return Object.keys(allListDataHubPage).map((firstKey) => {
      return Object.keys(allListDataHubPage[firstKey]).map((secondKey) => {
        const curr = allListDataHubPage[firstKey][secondKey];
        let contextTabToUse = contextTab;
        if (contextTab === 'ptypes' && keyTab === 'all') {
          contextTabToUse = 'default';
        }
        const isCurrent = contextTabToUse === firstKey && keyTab === secondKey;

        return (
          <div className={!isCurrent ? 'hideHubNode' : ''}>
            {curr}
          </div>
        );
      });
    });
  };


  return (
    <App
      {...appProps}
    >
      <MetaInfo
        domain={domain}
        seoData={seoData}
      />
      <div className="hubPage">
        <section className="hubcontent">
          <div className="map">
            {
              loadMap
              && (
                <MapImg
                  centerPoint={centerPoint}
                  device={device}
                  locationName={device}
                />
              )
            }

          </div>
          {
            isLoading ? (
              <>
                <div className="breadcrumb">
                  <Breadcrumb
                    data={breadcrumb}
                    isDesktop={device && device.indexOf('desktop') >= 0}
                    siteUrl={config.siteUrl}
                  />
                </div>
                <div className="intro">
                  <h1>
                    {titleMessage}
                  </h1>
                  <menu>
                    {
                      createHubPageChannelsTab()
                    }
                  </menu>
                </div>
                <div className="spinnerContainer">
                  <Spinner valignCenter="true" size="l" color="b" />
                </div>
                <div className="hubpageHideAll">
                  <>
                    {
                      SEOPageFormatSelects(
                        pTypesMenuValues,
                        ptype,
                        onButtonClick,
                        onSelectChange,
                        'ptypes',
                        onlyAuction,
                        shortRent,
                      )
                    }
                    {
                      shouldShowNumRoomsMenu && SEOPageFormatSelects(
                        numRoomMenuValues,
                        appNRooms,
                        onButtonClick,
                        onSelectChange,
                        'numrooms',
                        onlyAuction,
                        shortRent,
                      )
                    }
                  </>
                  {calculateHideGoToSrp()}
                  {withTowns}
                  {
                    createHubPageDataToRender()
                  }
                </div>
              </>
            ) :
              <>
                <div className="breadcrumb">
                  <Breadcrumb data={breadcrumb} />
                </div>
                <div className="intro">
                  <h1>
                    {titleMessage}
                  </h1>

                  <menu>
                    {
                      createHubPageChannelsTab()
                    }
                    {
                      SEOPageFormatSelects(
                        pTypesMenuValues,
                        ptype,
                        onButtonClick,
                        onSelectChange,
                        'ptypes',
                        onlyAuction,
                        shortRent,
                      )
                    }
                    {
                      shouldShowNumRoomsMenu && SEOPageFormatSelects(
                        numRoomMenuValues,
                        appNRooms,
                        onButtonClick,
                        onSelectChange,
                        'numrooms',
                        onlyAuction,
                        shortRent,
                      )
                    }
                    {shouldShowLicenseTypeGroupsMenu && SEOPageFormatSelects(
                      shouldShowLicenseTypeGroupsMenu,
                      licenseTypeGroup,
                      onButtonClick,
                      onSelectChange,
                      'licenseTypeGroups',
                      onlyAuction,
                      shortRent,
                    )}
                  </menu>
                </div>
                {goToSRP}
                {withTowns}
                {createHubPageDataToRender()}
              </>
          }
        </section>
      </div>
    </App>
  );
};

HubPageComponent.propTypes = propTypes;
HubPageComponent.defaultProps = defaultProps;
const HubPage = UiHandlerHOC(HubPageComponent, fetchHubPage);
export default HubPage;
